import { FormattedMessage } from 'react-intl';
import { Outlet } from 'react-router-dom';

import Tab from 'src/registry/components/navigation/Tab';
import TabRow from 'src/registry/components/navigation/TabRow';
import { subscriptionItemsMessages } from 'src/features/subscriptionItems/utils/messages';
import { chargesMessages } from 'src/features/charges/utils/messages';
import { financialDocumentsMessages } from 'src/features/financialDocuments/utils/messages';
import { paymentsMessages } from 'src/features/payments/utils/messages';
import { discountsMessages } from 'src/features/discounts/utils/messages';
import useHasPermissions from 'src/utils/useHasPermissions';
import { PERMISSION } from 'src/features/auth/types';

/**
 * Tab row for the subscription dashboard. The panels are the child routes declared in HomeRoutes.
 */
const SubscriptionDashboardTables = () => {
    const permissionAccessSubscriptions = useHasPermissions([PERMISSION.ACCESS_SUBSCRIPTIONS]);
    const permissionAccessCharges = useHasPermissions([PERMISSION.ACCESS_CHARGES]);
    const permissionAccessFinancialDocuments = useHasPermissions([PERMISSION.ACCESS_FINANCIAL_DOCUMENTS]);
    const permissionAccessPayments = useHasPermissions([PERMISSION.ACCESS_PAYMENTS]);
    const permissionAccessDiscounts = useHasPermissions([PERMISSION.ACCESS_DISCOUNTS]);

    const showTabsAndTables =
        permissionAccessSubscriptions ||
        permissionAccessCharges ||
        permissionAccessFinancialDocuments ||
        permissionAccessPayments ||
        permissionAccessDiscounts;

    return (
        <div className="grid flex-3 grid-cols-1 pr-8">
            {showTabsAndTables && (
                <>
                    <TabRow>
                        {permissionAccessSubscriptions && (
                            <Tab to="subscription-items" preventScrollReset>
                                <FormattedMessage {...subscriptionItemsMessages.subscriptionItems} />
                            </Tab>
                        )}
                        {permissionAccessCharges && (
                            <Tab to="charges" preventScrollReset>
                                <FormattedMessage {...chargesMessages.charges} />
                            </Tab>
                        )}
                        {permissionAccessFinancialDocuments && (
                            <Tab to="financial-documents" preventScrollReset>
                                <FormattedMessage {...financialDocumentsMessages.financialDocuments} />
                            </Tab>
                        )}
                        {permissionAccessPayments && (
                            <Tab to="payments" preventScrollReset>
                                <FormattedMessage {...paymentsMessages.payments} />
                            </Tab>
                        )}
                        {permissionAccessDiscounts && (
                            <Tab to="discounts" preventScrollReset>
                                <FormattedMessage {...discountsMessages.discounts} />
                            </Tab>
                        )}
                    </TabRow>
                    <div className="mt-4">
                        <Outlet />
                    </div>
                </>
            )}
        </div>
    );
};

export default SubscriptionDashboardTables;
